import { Action } from '@ngrx/store';
import * as model from '../models';

// Export Constants
export const LOGIN = '[Auth] Login';
export const LOGOUT = '[Auth] Logout';
export const RE_LOGIN = '[Auth] Relogin';
export const LOGIN_FAIL = '[Auth] Login Fail';
export const AUTO_LOGOUT = '[Auth] Auto Logout';
export const CLEAN_LOGIN = '[Auth] Clean Login';
export const LOCK_ACCOUNT = '[Auth] Lock Account';
export const LOGIN_SUCCESS = '[Auth] Login Success';
export const LOGIN_REDIRECT = '[Auth] Login Redirect';
export const LOGOUT_SUCCESS = '[Auth] Logout Success';
export const RE_LOGIN_SUCCESS = '[Auth] Relogin Success';
export const USER_INFORMATION = '[Auth] Get User Information';
export const CHECK_AUTO_LOGOUT = '[Auth] Check Auto Logout';
export const SESSION_TIME_WARNING = '[Auth] Session Time Warning For AutoLogout';
export const USER_INFORMATION_REFRESH = '[Auth] Get User Information Refresh';
export const STAFF_USER_INFORMATION_REFRESH = '[Auth] Get Staff User Information Refresh';
export const LOGIN_SUCCESS_NO_REDIRECT = '[Auth] Login Success No Redirect';
export const REFRESH_SESSION_EXPIRATION = '[Auth] Refresh Session Token Expiration';
export const LOGIN_SUCCESS_PASSWORD_RESET = '[Auth] Login Success On Password Reset';
export const USER_INFORMATION_REFRESH_SUCCESS = '[Auth] Get User Information Refresh Success';

export const ACTIVATE_ACCOUNT = '[Auth] Activate Account';
export const GET_EMAIL_BY_TOKEN = '[Auth] Get Email By Token for Activation';
export const ACTIVATE_ACCOUNT_FAIL = '[Auth] Activate Account Fail';
export const ACTIVATE_ACCOUNT_LOGIN = '[Auth] Activate Account in the Login';
export const CHECK_ACTIVATION_TOKEN = '[Auth] Activation Token';
export const ACTIVATION_TOKEN_EXPIRED = '[Auth] Activation Token Expired';
export const GET_EMAIL_BY_TOKEN_SUCCESS = '[Auth] Get Email By Token for Activation Success';

export const TOGGLE_TRUSTED = '[Auth] Toggle Trusted';
export const RESEND_CODE = '[Auth] Resend Verification Code';
export const RESEND_EMAIL = '[Auth] Resend Verification Email';
export const TWO_FACTOR_CALL = '[Auth] 2FA Call';
export const TWO_FACTOR_SWITCH = '[Auth] 2FA Switch';
export const VERIFY_PHONE_NUMBER = '[Auth] Verify Phone Number';
export const VERIFY_PHONE_REDIRECT = '[Auth] Redirect to the Phone Verification Page';
export const TWO_FACTOR_CALL_SUCCESS = '[Auth] 2FA Call Success';
export const VERIFY_PHONE_NUMBER_FAIL = '[Auth] Verify Phone Number Fail';

export const FORCE_PASSWORD_REDIRECT = '[Auth] Redirect to Force Password Page';
export const FORCE_PASSWORD_CLEAR = '[Auth] Clear to Force Password Page';

export const FORGOT_FAIL = '[Auth] Forgot Password Fail';
export const FORGOT_CLEAN = '[Auth] Clean Forgot Password Status';
export const FORGOT_REDIRECT = '[Auth] Forgot Password Redirect';
export const FORGOT_EMAIL_SENT = '[Auth] Forgot Password Email Sent';
export const FORGOT_EMAIL_SUCCESS = '[Auth] Forgot Password Email Sent Succesfully';

export const RESET_CLEAN = '[Auth] Clean Reset Password Status';
export const RESET_PASSWORD = '[Auth] Reset Password';
export const CHECK_RESET_TOKEN = '[Auth] Check Reset Token';
export const RESET_PASSWORD_SUCCESS = '[Auth] Reset Password Success';
export const CHECK_RESET_TOKEN_FAIL = '[Auth] Check Reset Token Fail';
export const CHECK_RESET_TOKEN_SUCCESS = '[Auth] Check Reset Token Success';

export const SIGNUP = '[Auth] Sign Up';
export const SIGNUP_FAIL = '[Auth] Sign Up Fail';
export const SIGNUP_CLEAN = '[Auth] Clean Sign Up Status';
export const SIGNUP_SUCCESS = '[Auth] Sign Up Success';
export const SIGNUP_REDIRECT = '[Auth] Sign Up Redirect';

export const DASHBOARD_REDIRECT = '[Auth] Dashboard Redirect';
export const PROPER_REDIRECT = '[Auth] Proper Redirect';
export const DASHBOARD_STAFF_REDIRECT = '[Auth] Dashboard Staff Redirect';

export const CHANGE_FORCE_PASSWORD = '[Auth] Change Force Password';
export const CHANGE_FORCE_PASSWORD_SUCCESS = '[Auth] Change Force Password Success';
export const CHANGE_FORCE_PASSWORD_FAIL = '[Auth] Change Force Password Fail';

export const ACCOUNTS_COSTUMER_STAFF_REDIRECT = '[Auth] Accounts Costumer Staff Redirect';

// Export Actions
export class Dummy implements Action {
  readonly type = '[Auth] Dummy';
}
export class Login implements Action {
  readonly type = LOGIN;
  constructor(public payload: model.ILoginUser) {}
}
export class Logout implements Action {
  readonly type = LOGOUT;
  constructor() {}
}
export class Signup implements Action {
  readonly type = SIGNUP;
  constructor(public payload: any) {}
}
export class ReLogin implements Action {
  readonly type = RE_LOGIN;
}
export class LoginFail implements Action {
  readonly type = LOGIN_FAIL;
  constructor(public payload: { email: string, message: string }) {}
}
export class AutoLogout implements Action {
  readonly type = AUTO_LOGOUT;
  constructor(public payload: { time: number, token: string }) {}
}
export class CleanLogin implements Action {
  readonly type = CLEAN_LOGIN;
}
export class CleanReset implements Action {
  readonly type = RESET_CLEAN;
}
export class ToggleTrusted implements Action {
  readonly type = TOGGLE_TRUSTED;
}
export class ResendCode implements Action {
  readonly type = RESEND_CODE;
  constructor(public payload: { authorization_code: string }) {}
}
export class ResendEmail implements Action {
  readonly type = RESEND_EMAIL;
  constructor(public payload: { authorization_code: string }) {}
}
export class SignUpFail implements Action {
  readonly type = SIGNUP_FAIL;
  constructor(public payload: string) {}
}
export class CleanForgot implements Action {
  readonly type = FORGOT_CLEAN;
}
export class CleanSignup implements Action {
  readonly type = SIGNUP_CLEAN;
}
export class LockAccount implements Action {
  readonly type = LOCK_ACCOUNT;
  constructor(public payload: { email: string }) {}
}
export class LoginSuccess implements Action {
  readonly type = LOGIN_SUCCESS;
  constructor(public payload: { time: number, token: string, staff: boolean, resetPassword: boolean, requireSetEmail: boolean, tfa_grace?: string }) {}
}
export class LoginRedirect implements Action {
  readonly type = LOGIN_REDIRECT;
}
export class LogoutSuccess implements Action {
  readonly type = LOGOUT_SUCCESS;
}
export class ResetPassword implements Action {
  readonly type = RESET_PASSWORD;
  constructor(public payload: model.ILoginUser) {}
}
export class SignupSuccess implements Action {
  readonly type = SIGNUP_SUCCESS;
}
export class TwoFactorCall implements Action {
  readonly type = TWO_FACTOR_CALL;
  constructor(public payload: { authorization_code: string }) {}
}
export class TwoFactorSwitch implements Action {
  readonly type = TWO_FACTOR_SWITCH;
  constructor(public payload: { tfa_last: string | null }) {}
}
export class ForgotRedirect implements Action {
  readonly type = FORGOT_REDIRECT;
}
export class ReloginSuccess implements Action {
  readonly type = RE_LOGIN_SUCCESS;
  constructor(public payload: { time: number }) {}
}
export class SignupRedirect implements Action {
  readonly type = SIGNUP_REDIRECT;
}
export class ActivateAccount implements Action {
  readonly type = ACTIVATE_ACCOUNT;
  constructor(public payload: model.ILoginUser) {}
}
export class CheckAutoLogout implements Action {
  readonly type = CHECK_AUTO_LOGOUT;
}
export class CheckResetToken implements Action {
  readonly type = CHECK_RESET_TOKEN;
  constructor(public payload: { reset_token: string }) {}
}
export class ForgotEmailFail implements Action {
  readonly type = FORGOT_FAIL;
  constructor(public payload: string) {}
}
export class ForgotEmailSent implements Action {
  readonly type = FORGOT_EMAIL_SENT;
  constructor(public payload: { email: string }) {}
}
export class GetEmailByToken implements Action {
  readonly type = GET_EMAIL_BY_TOKEN;
  constructor(public payload: { activation_token: string, activate: boolean }) {}
}
export class UserInformation implements Action {
  readonly type = USER_INFORMATION;
  constructor(public payload: any) {}
}
export class DashboardRedirect implements Action {
  readonly type = DASHBOARD_REDIRECT;
}
export class ProperRedirect implements Action {
  readonly type = PROPER_REDIRECT;
}
export class DashboardStaffRedirect implements Action {
  readonly type = DASHBOARD_STAFF_REDIRECT;
}
export class VerifyPhoneNumber implements Action {
  readonly type = VERIFY_PHONE_NUMBER;
  constructor(public payload: { code: string, authorization_code: string, staff: boolean, tfaLast: string, tfaToken: string | null, trusted: boolean }) {}
}
export class SessionTimeWarning implements Action {
  readonly type = SESSION_TIME_WARNING;
}
export class ActivateAccountFail implements Action {
  readonly type = ACTIVATE_ACCOUNT_FAIL;
  constructor(public payload: string) {}
}
export class CheckResetTokenFail implements Action {
  readonly type = CHECK_RESET_TOKEN_FAIL;
}
export class VerifyPhoneRedirect implements Action {
  readonly type = VERIFY_PHONE_REDIRECT;
  constructor(public payload: { authorization_code: string, phone: string, staff?: boolean, tfa?: number, tfa_last?: string, tfa_token?: string, trusted?: boolean }) {}
}
export class ForcePasswordRedirect implements Action {
  readonly type = FORCE_PASSWORD_REDIRECT;
  constructor(public payload?: any) {}
}
export class ForcePasswordClearStore implements Action {
  readonly type = FORCE_PASSWORD_CLEAR;
}
export class CheckActivationToken implements Action {
  readonly type = CHECK_ACTIVATION_TOKEN;
  constructor(public payload: { activation_token: string, activate }) {}
}
export class ResetPasswordSuccess implements Action {
  readonly type = RESET_PASSWORD_SUCCESS;
  constructor(public payload: { time: number, token: string, staff: boolean, resetPassword: boolean, requireSetEmail: boolean }) {}
}
export class TwoFactorCallSuccess implements Action {
  readonly type = TWO_FACTOR_CALL_SUCCESS;
}
export class ActivateAccountLogin implements Action {
  readonly type = ACTIVATE_ACCOUNT_LOGIN;
  constructor(public payload: string) {}
}
export class VerifyPhoneNumberFail implements Action {
  readonly type = VERIFY_PHONE_NUMBER_FAIL;
  constructor(public payload: string) {}
}
export class ActivationTokenExpired implements Action {
  readonly type = ACTIVATION_TOKEN_EXPIRED;
}
export class CheckResetTokenSuccess implements Action {
  readonly type = CHECK_RESET_TOKEN_SUCCESS;
}
export class ForgotEmailSentSuccess implements Action {
  readonly type = FORGOT_EMAIL_SUCCESS;
}
export class GetEmailByTokenSuccess implements Action {
  readonly type = GET_EMAIL_BY_TOKEN_SUCCESS;
  constructor(public payload: any) {}
}
export class LoginSuccessNoRedirect implements Action {
  readonly type = LOGIN_SUCCESS_NO_REDIRECT;
  constructor(public payload: { time: number, token: string, staff: boolean, resetPassword: boolean, requireSetEmail: boolean }) {}
}
export class UserInformationRefresh implements Action {
  readonly type = USER_INFORMATION_REFRESH;
}
export class StaffUserInformationRefresh implements Action {
  readonly type = STAFF_USER_INFORMATION_REFRESH;
}
export class RefreshSessionExpiration implements Action {
  readonly type = REFRESH_SESSION_EXPIRATION;
  constructor(public payload: number) {}
}
export class LoginSuccessOnPasswordReset implements Action {
  readonly type = LOGIN_SUCCESS_PASSWORD_RESET;
}
export class UserInformationRefreshSuccess implements Action {
  readonly type = USER_INFORMATION_REFRESH_SUCCESS;
  constructor(public payload: any) {}
}
export class ChangeForcePassword implements Action {
  readonly type = CHANGE_FORCE_PASSWORD;
  constructor(public payload: any) {}
}
export class ChangeForcePasswordSuccess implements Action {
  readonly type = CHANGE_FORCE_PASSWORD_SUCCESS;
}
export class ChangeForcePasswordFail implements Action {
  readonly type = CHANGE_FORCE_PASSWORD_FAIL;
  constructor(public payload: string) {}
}
export class AccountsCustomerStaffRedirect implements Action {
  readonly type = ACCOUNTS_COSTUMER_STAFF_REDIRECT;
  constructor() {}
}

// Export Actions
export type Actions =
  | Dummy
  | Login
  | Logout
  | Signup
  | ReLogin
  | LoginFail
  | CleanLogin
  | CleanReset
  | ToggleTrusted
  | ResendCode
  | ResendEmail
  | SignUpFail
  | CleanForgot
  | CleanSignup
  | LockAccount
  | LoginSuccess
  | LoginRedirect
  | LogoutSuccess
  | ResetPassword
  | SignupSuccess
  | TwoFactorCall
  | TwoFactorSwitch
  | ForgotRedirect
  | ReloginSuccess
  | SignupRedirect
  | ActivateAccount
  | CheckAutoLogout
  | CheckResetToken
  | ForgotEmailFail
  | ForgotEmailSent
  | GetEmailByToken
  | UserInformation
  | VerifyPhoneNumber
  | SessionTimeWarning
  | ActivateAccountFail
  | CheckResetTokenFail
  | VerifyPhoneRedirect
  | CheckActivationToken
  | ResetPasswordSuccess
  | TwoFactorCallSuccess
  | ActivateAccountLogin
  | VerifyPhoneNumberFail
  | ActivationTokenExpired
  | CheckResetTokenSuccess
  | ForgotEmailSentSuccess
  | GetEmailByTokenSuccess
  | LoginSuccessNoRedirect
  | UserInformationRefresh
  | RefreshSessionExpiration
  | LoginSuccessOnPasswordReset
  | UserInformationRefreshSuccess
  | DashboardRedirect
  | ProperRedirect
  | DashboardStaffRedirect
  | ForcePasswordRedirect
  | ForcePasswordClearStore
  | ChangeForcePassword
  | ChangeForcePasswordSuccess
  | ChangeForcePasswordFail
  | AccountsCustomerStaffRedirect;



// WEBPACK FOOTER //
// ./src/app/auth/actions/auth.actions.ts